import { useQuery } from '@tanstack/react-query';
import { SuitabilityReportSectionDrafts } from './types';

export function useSuitabilityReportDrafts(companyId: string, suitabilityReportId: string | null) {
  return useQuery<SuitabilityReportSectionDrafts>({
    queryKey: [
      'admin',
      'companies',
      companyId,
      'suitability-reports',
      suitabilityReportId,
      'section-drafts',
    ],
    enabled: !!suitabilityReportId,
  });
}
